/**
 * @desc 查询硅铝质材料需求周计划
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.IdRequest,
): Promise<defs.StandardReturn<defs.PlanWeekSiliconAluminumMaterialResponse>> {
  return defHttp.post({
    url: '/web/plan/week/queryPlanSiliconAluminumMaterial',
    data,
  });
}

export function mock(
  data: defs.IdRequest,
): Promise<defs.StandardReturn<defs.PlanWeekSiliconAluminumMaterialResponse>> {
  return defHttp.post({
    url: '/mock/web/plan/week/queryPlanSiliconAluminumMaterial',
    data,
  });
}
